import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './styles.module.css';

type SortHeaderProps = {
  columnNameCode: string;
  sortOrder: string;
  onSort: () => void;
  isSorted: boolean;
};

const SortHeader: React.FC<SortHeaderProps> = ({ columnNameCode, sortOrder, onSort, isSorted }: SortHeaderProps) => {
  const getSortIcon = () => {
    if (!isSorted) {
      return '';
    }
    if (sortOrder === 'asc') {
      return 'is24-icon-arrow-up';
    } else {
      return 'is24-icon-arrow-down';
    }
  };
  return (
    <button data-testid={`${columnNameCode}`} className={styles.sortLink} onClick={onSort}>
      <FormattedMessage id={columnNameCode} />
      <span className={`${styles.sortIcon} ${getSortIcon()}`} />
    </button>
  );
};

export default SortHeader;
